import { useCallback, useState } from 'react';
import { useHistory } from 'react-router';
import BasicButton from '../../../components/BasicButton';
import BasicInput from '../../../components/BasicInput';
import ImageUploader from '../../../components/ImageUploader';
import { uploadNews } from '../../../misc/lib/news';
import routes from '../../../misc/routes';
import NewsBodyEditor from './NewsBodyEditor';
import './UploadNewsPage.scss';

const UploadNewsPage = () => {
  const history = useHistory();

  const [ title, setTitle ] = useState('');
  const [ coverPhoto, setCoverPhoto ] = useState<File>();
  const [ body, setBody ] = useState('');
  const [ uploading, setUploading ] = useState(false);

  const doUploadNews = useCallback(() => {
    if (!title || !coverPhoto || !body) return;

    setUploading(true);
    uploadNews(title, coverPhoto, body).then((id) => {
      history.push(routes.news.children.specificNews.path.replace(':id', id));
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setUploading(false);
    });
  }, [ title, coverPhoto, body, history ]);

  return (
    <div className="uploadnewspage-container">
      <h1>Új hír feltöltése</h1>
      <BasicInput placeholder="Cím" text={ title } onTextChanged={ setTitle } />
      <ImageUploader img={ coverPhoto } onImgChanged={ setCoverPhoto } />
      <NewsBodyEditor text={ body } onTextChanged={ setBody } />
      <div className="format-guide"></div>
      <BasicButton text="Feltöltés" type="primary" onClick={ doUploadNews }
        working={ uploading } />
    </div>
  );
};

export default UploadNewsPage;
